import React, { useEffect, useState } from 'react';

/* Icons */
import CheckIcon from '~/../symbols/check.svg';

/* Common */
import { Icon } from '~/components/common';

export default function ConversionComponentChoice(component) {
    const [usps, setUsps] = useState([]);

    useEffect(() => {
        if (component.metadata && component.metadata.bulletList) setUsps(component.metadata.bulletList);
    }, [component]);

    return (
        <div className="col-12">
            <ul className="list list--usps">
                {usps.map((usp, index) => (
                    <li key={index} className="list__item">
                        <Icon
                            size={12}
                            className={`btn__icon icon`}
                            url={CheckIcon?.url}
                        />
                        {usp}
                    </li>
                ))}
            </ul>
        </div>
    );
}
